import { useEffect, useState } from "react"
import { MdReportGmailerrorred } from "react-icons/md"
import './AreYouSure.css'


export default function AreYouSure({isActive, handle, title}){
  const [active, setActive] = useState(false)
  useEffect(()=>{
    setActive(isActive)
  },[isActive])
  return (<>
  {active?<>
  <div className="backdrop" onClick={()=>{handle()}}>
  </div>
  <div className="warning">
    <span className="text-red-500"><MdReportGmailerrorred size={150}/></span>
    <span className="text-white font-semibold text-xl">{title}</span>
    <span className="text-white my-3">Esta acción no puede revertirse</span>
    <div className="flex gap-4">
    <button className="light-button cancel mt-4" onClick={()=>{handle()}}>Cancelar</button>
    <button className="light-button mt-4" onClick={()=>{handle('accepted')}}>Aceptar</button>
    </div>
  </div>
  </>:<></>}
  </>)
}